import { apiRequest } from '../../apiCall'


export const getTeamMember = (params) => apiRequest('TeamMember.GetMembers', { ...params }, "")
export const addTeamMember = (params, userId, webAddress) => apiRequest('TeamMember.AddMember', { ...params }, `${userId ? "?ownerUserId=" + userId : ""}`)
export const removeTeamMember = (params) => apiRequest('TeamMember.DeleteMember', {}, params)
export const updateTeamMember = (params, userId, webAddress) => {
    apiRequest('TeamMember.UpdateMember', { ...params }, `${userId ? "?ownerUserId=" + userId : ''}`)
}

